import {USER_COHORT, ENTITLEMENT_SOURCE} from '../auth/constants';

export const QUESTIONNAIRE_TYPE = {
    wizard: 'WIZARD',
    singlePage: 'SINGLE_PAGE',
}

export const QUESTION_TYPE = {
    selection: 'selection',
    rating: 'rating',
}

export const QUESTIONNAIRE_CATEGORY = {
    onboarding: 'onboarding',
    feedback: 'feedback',
}

export const QUESTIONNAIRE_SUBCATEGORY = {
    [ENTITLEMENT_SOURCE.optum]: 'b2b001',
    [USER_COHORT.d2c]: 'd2c001',
    series: 'series',
}
